import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  AppDownload,
  DriversDetails,
  Footer,
  Header,
  WhyDriver,
} from "../components";

const Drivers = () => {
  return (
    <>
      <Header />
      <Wrapper>
        <div className="drivers__row__wrapper">
          <div className="drivers__row">
            <div className="drivers__header_h1">
              <h1>Sign up to drive and increase your earnings.</h1>
            </div>
            <div className="drivers__header_p">
              <p>
                Earn more by helping individuals and companies deliver packages.
              </p>
            </div>
            <div className="drivers__btn">
              <Link
                onClick={() =>
                  window.open("https://app.wecanrush.com/register", "_blank")
                }
              >
                <div className="drivers__first_btn">
                  <button>Create a free account</button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="svgMain">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <DriversDetails />
        <WhyDriver />
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  .drivers__row__wrapper {
    background: #e5edfc;
    width: 100% !important;
    padding-bottom: 87px !important;
  }
  .svgMain {
    margin: -40px;
  }
  .drivers__row {
    padding: 0 24px;
    max-width: 1170px;
    margin: auto;
  }
  @media screen and (max-width: 440px) {
    .drivers__row {
      width: 100% !important;
      padding: 0 20px;
    }
    .svgMain {
      margin: 0;
    }
    .section-center {
      width: 100%;
    }

    .drivers__header_p {
      padding: 0;
      p {
        width: 100% !important;
        font-weight: 500 !important;
        font-family: "Manrope" !important;
        color: #455880 !important;
        margin-top: 0px !important;
      }
    }

    .drivers__header_h1 h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #6300ff;
      width: 100% !important;
      font-size: 31px !important;
      line-height: 50px !important;
    }

    .drivers__header_p p {
      font-size: 16px !important;
      line-height: 30px !important;
      width: 100% !important;
    }
    .drivers__first_btn button {
      width: 165.71px !important;
      height: 40px !important;
      font-size: 14px !important;
    }

    .drivers__row {
      width: 100% !important;
      padding: 0 24px;
      background: #e5edfc;
      width: 100%;
      padding-bottom: 87px !important;
    }
  }

  .individuals {
    max-width: 1170px;
    padding: 0;
    width: 100%;
  }
  svg {
    /* padding-top: -40px; */
  }

  .drivers__header_h1 {
    padding: 0;
    padding-top: 180px;
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      width: 655px;
      height: 144px;
      color: #6300ff;
    }
  }

  .drivers__header_p {
    padding: 0;
    p {
      font-style: normal;
      font-size: 20px;
      line-height: 38px;
      margin-top: 20px;
      letter-spacing: 0.3px;
      width: 50%;
      font-weight: 500 !important;
      font-family: "Manrope" !important;
      color: #455880 !important;
    }
  }

  .drivers__btn {
    display: flex;
    align-items: center;
    margin-top: 107px;
  }
  .drivers__first_btn button {
    background: #1d66ff;
    box-shadow: 0px 2px 4px rgba(0, 16, 75, 0.2);
    border-radius: 5px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    width: 232px;
    height: 56px;
    border: none;
    outline: none;
  }
`;

export default Drivers;
